import { createFileRoute } from "@tanstack/react-router";
import WhatHappensIfAntidepressantsDontWork from "@/pages/articles/WhatHappensIfAntidepressantsDontWork";
export const Route = createFileRoute(
  "/what-happens-if-antidepressants-dont-work",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "What Happens If Antidepressants Dont Work | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What happens when antidepressants don’t work? Learn about TMS, SAINT TMS, and next steps for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "What Happens If Antidepressants Dont Work | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What happens when antidepressants don’t work? Learn about TMS, SAINT TMS, and next steps for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-happens-if-antidepressants-dont-work",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-happens-if-antidepressants-dont-work",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatHappensIfAntidepressantsDontWork />;
}
